var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none",
    viewBox: "0 0 512 512",
    id: "download",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M114.612 158.843C126.373 147.082 145.443 147.082 157.205 158.843L225.882 227.521 225.882 75.3922C225.882 58.7587 239.366 45.2746 256 45.2746 272.633 45.2746 286.117 58.7587 286.117 75.3922L286.117 227.521 354.795 158.843C366.557 147.082 385.626 147.082 397.388 158.843 409.15 170.605 409.15 189.675 397.388 201.436L277.296 321.528C265.535 333.29 246.465 333.29 234.703 321.528L114.612 201.436C102.85 189.675 102.85 170.605 114.612 158.843ZM60.2354 421.647C60.2354 405.013 73.7195 391.529 90.353 391.529H421.647C438.281 391.529 451.765 405.013 451.765 421.647 451.765 438.28 438.281 451.765 421.647 451.765H90.353C73.7195 451.765 60.2354 438.28 60.2354 421.647Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.2b600b57db614480dab6d52357978cb1.svg";
export { ForwardRef as ReactComponent };